export default "__VITE_ASSET__CrWKjJZV__"